import React from 'react'

const BatterDetailSecondMobileTabRegular = ({ dataTable, seasonsummary, selectedGyear }) => {
  return (
    <>
      {/* 시즌 정규리그 기록 mobile */}
      <article className="player_record_content regular_league mb_mode">
        <div className="player_record">
          <div className="container">
            <h5>{selectedGyear} {dataTable.title}</h5>
          </div>
          <div className="container table">
            <table className="btD7161b wid100per">
              <caption>{selectedGyear} {dataTable.title}</caption>
              <colgroup>
                {
                  dataTable.data.map((v, i) => (
                    <col key={i} width={v.cols} />
                  ))
                }
              </colgroup>
              <tbody>
                <tr>
                  {
                    dataTable.data.map((v, i) => (
                      <th key={i}>{v.head[0]}</th>
                    ))
                  }
                </tr>
                <tr>
                  {
                    seasonsummary
                      ? dataTable.data.map((v, i) => (
                        <td key={i}>{seasonsummary[v.bodyParam[0]]}</td>
                      ))
                      : <td colSpan={dataTable.data.length}>데이터가 없습니다.</td>
                  }

                </tr>
                <tr>
                  {
                    dataTable.data.map((v, i) => (
                      <th key={i}>{v.head[1]}</th>
                    ))
                  }
                </tr>
                <tr>
                  {
                    seasonsummary 
                      ? dataTable.data.map((v, i) => (
                        <td key={i}>{seasonsummary[v.bodyParam[1]]}</td>
                      ))
                      : <td colSpan={dataTable.data.length}>데이터가 없습니다.</td>
                  }
                </tr>
                <tr>
                  {
                    dataTable.data.map((v, i) => (
                      <th key={i}>{v.head[2]}</th>
                    ))
                  }
                </tr>
                <tr>
                  {
                    seasonsummary 
                      ? dataTable.data.map((v, i) => (
                        <td key={i}>{seasonsummary[v.bodyParam[2]]}</td>
                      ))
                      : <td colSpan={dataTable.data.length}>데이터가 없습니다.</td>
                  }
                </tr>
                <tr>
                  {
                    dataTable.data.map((v, i, arr) => (
                      v.head[3] &&
                      <th key={i} colSpan={
                        (arr.length > v.head.length && v.head.length - 1 === i)
                          ? arr.length - i
                          : 1
                      }>{v.head[3]}</th>
                    ))
                  }
                </tr>
                <tr>
                  {
                    seasonsummary 
                      ? dataTable.data.map((v, i, arr) => (
                        v.bodyParam[3] &&
                        <td key={i} colSpan={
                          (arr.length > v.bodyParam.length && v.bodyParam.length - 1 === i)
                            ? arr.length - i
                            : 1
                        }>{seasonsummary[v.bodyParam[3]]}</td>
                      ))
                      : <td colSpan={dataTable.data.length}>데이터가 없습니다.</td>
                  }
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </article>
      {/* // 시즌 정규리그 기록 mobile */}
    </>
  )
}

export default BatterDetailSecondMobileTabRegular
